import './crop-image.modal.scss';

export default function CropImageModal($scope, close, source, title, onUpload, $gl,
                                       $file, $auth, $alert, $t) {
  'ngInject';

  $scope.cropper = {
    area: {},
    sourceImage: source,
    croppedImage: null,
    title: title
  };

  $scope.upload = () => {
    if (!$scope.cropper.sourceImage || !$scope.cropper.croppedImage) {
      return;
    }

    const image = $scope.cropper.sourceImage;
    if (!$file.isValidFile(image, [$file.mimeImages])) {
      return;
    }

    $gl.show();
    const cropOptions = {
      x: $scope.cropper.area.cropImageLeft,
      y: $scope.cropper.area.cropImageTop,
      w: $scope.cropper.area.cropImageWidth,
      h: $scope.cropper.area.cropImageHeight
    };

    onUpload($scope.cropper.sourceImage, cropOptions,
      (response) => {
        $gl.hide();
        $auth.user().avatar = response.avatar;
        close(response);
      },
      (error) => {
        $gl.hide();
        $alert.processError(error, $t('shared.modals.crop_image.upload_picture_error'));
      }
    );
  };

  $scope.close = () => {
    close(false);
  }
}